const convertAccentsToCSS = (accents) => ({
    '--accents-primary-base-default': accents.primary.base.default,
    '--accents-primary-base-action': accents.primary.base.action,
    '--accents-primary-base-active': accents.primary.base.active,
    '--accents-primary-base-active-action': accents.primary.base.activeAction,
    '--accents-primary-text-default': accents.primary.text.default,
    '--accents-primary-text-action': accents.primary.text.action,
    '--accents-primary-text-active': accents.primary.text.active,
    '--accents-primary-text-active-action': accents.primary.text.activeAction,
    '--accents-secondary-base-default': accents.secondary.base.default,
    '--accents-secondary-base-action': accents.secondary.base.action,
    '--accents-secondary-base-active': accents.secondary.base.active,
    '--accents-secondary-base-active-action': accents.secondary.base.activeAction,
    '--accents-secondary-text-default': accents.secondary.text.default,
    '--accents-secondary-text-action': accents.secondary.text.action,
    '--accents-secondary-text-active': accents.secondary.text.active,
    '--accents-secondary-text-active-action': accents.secondary.text.activeAction,
    '--accents-tertiary-base-default': accents.tertiary.base.default,
    '--accents-tertiary-base-action': accents.tertiary.base.action,
    '--accents-tertiary-base-active': accents.tertiary.base.active,
    '--accents-tertiary-base-active-action': accents.tertiary.base.activeAction,
    '--accents-tertiary-text-default': accents.tertiary.text.default,
    '--accents-tertiary-text-action': accents.tertiary.text.action,
    '--accents-tertiary-text-active': accents.tertiary.text.active,
    '--accents-tertiary-text-active-action': accents.tertiary.text.activeAction,
});
const convertAccentsToObject = (accents) => ({
    accentsPrimaryBaseDefault: accents.primary.base.default,
    accentsPrimaryBaseAction: accents.primary.base.action,
    accentsPrimaryBaseActive: accents.primary.base.active,
    accentsPrimaryBaseActiveAction: accents.primary.base.activeAction,
    accentsPrimaryTextDefault: accents.primary.text.default,
    accentsPrimaryTextAction: accents.primary.text.action,
    accentsPrimaryTextActive: accents.primary.text.active,
    accentsPrimaryTextActiveAction: accents.primary.text.activeAction,
    accentsSecondaryBaseDefault: accents.secondary.base.default,
    accentsSecondaryBaseAction: accents.secondary.base.action,
    accentsSecondaryBaseActive: accents.secondary.base.active,
    accentsSecondaryBaseActiveAction: accents.secondary.base.activeAction,
    accentsSecondaryTextDefault: accents.secondary.text.default,
    accentsSecondaryTextAction: accents.secondary.text.action,
    accentsSecondaryTextActive: accents.secondary.text.active,
    accentsSecondaryTextActiveAction: accents.secondary.text.activeAction,
    accentsTertiaryBaseDefault: accents.tertiary.base.default,
    accentsTertiaryBaseAction: accents.tertiary.base.action,
    accentsTertiaryBaseActive: accents.tertiary.base.active,
    accentsTertiaryBaseActiveAction: accents.tertiary.base.activeAction,
    accentsTertiaryTextDefault: accents.tertiary.text.default,
    accentsTertiaryTextAction: accents.tertiary.text.action,
    accentsTertiaryTextActive: accents.tertiary.text.active,
    accentsTertiaryTextActiveAction: accents.tertiary.text.activeAction,
});
const convertAccentIllustrationsToCSS = (brandIllustrations) => ({
    '--accents-primary-tint-1': brandIllustrations.primary.tint1,
    '--accents-primary-tint-2': brandIllustrations.primary.tint2,
    '--accents-primary-tint-3': brandIllustrations.primary.tint3,
    '--accents-primary-tint-4': brandIllustrations.primary.tint4,
    '--accents-primary-tint-5': brandIllustrations.primary.tint5,
    '--accents-primary-tint-6': brandIllustrations.primary.tint6,
    '--accents-secondary-tint-1': brandIllustrations.secondary.tint1,
    '--accents-secondary-tint-2': brandIllustrations.secondary.tint2,
    '--accents-secondary-tint-3': brandIllustrations.secondary.tint3,
    '--accents-secondary-tint-4': brandIllustrations.secondary.tint4,
    '--accents-secondary-tint-5': brandIllustrations.secondary.tint5,
    '--accents-secondary-tint-6': brandIllustrations.secondary.tint6,
});
const convertAccentIllustrationsToObject = (brandIllustrations) => ({
    accentsPrimaryTint1: brandIllustrations.primary.tint1,
    accentsPrimaryTint2: brandIllustrations.primary.tint2,
    accentsPrimaryTint3: brandIllustrations.primary.tint3,
    accentsPrimaryTint4: brandIllustrations.primary.tint4,
    accentsPrimaryTint5: brandIllustrations.primary.tint5,
    accentsPrimaryTint6: brandIllustrations.primary.tint6,
    accentsSecondaryTint1: brandIllustrations.secondary.tint1,
    accentsSecondaryTint2: brandIllustrations.secondary.tint2,
    accentsSecondaryTint3: brandIllustrations.secondary.tint3,
    accentsSecondaryTint4: brandIllustrations.secondary.tint4,
    accentsSecondaryTint5: brandIllustrations.secondary.tint5,
    accentsSecondaryTint6: brandIllustrations.secondary.tint6,
});
const Accents = {
    primary: {
        base: {
            default: 'var(--accents-primary-base-default)',
            action: 'var(--accents-primary-base-action)',
            active: 'var(--accents-primary-base-active)',
            activeAction: 'var(--accents-primary-base-active-action)',
        },
        text: {
            default: 'var(--accents-primary-text-default)',
            action: 'var(--accents-primary-text-action)',
            active: 'var(--accents-primary-text-active)',
            activeAction: 'var(--accents-primary-text-active-action)',
        },
    },
    secondary: {
        base: {
            default: 'var(--accents-secondary-base-default)',
            action: 'var(--accents-secondary-base-action)',
            active: 'var(--accents-secondary-base-active)',
            activeAction: 'var(--accents-secondary-base-active-action)',
        },
        text: {
            default: 'var(--accents-secondary-text-default)',
            action: 'var(--accents-secondary-text-action)',
            active: 'var(--accents-secondary-text-active)',
            activeAction: 'var(--accents-secondary-text-active-action)',
        },
    },
    tertiary: {
        base: {
            default: 'var(--accents-tertiary-base-default)',
            action: 'var(--accents-tertiary-base-action)',
            active: 'var(--accents-tertiary-base-active)',
            activeAction: 'var(--accents-tertiary-base-active-action)',
        },
        text: {
            default: 'var(--accents-tertiary-text-default)',
            action: 'var(--accents-tertiary-text-action)',
            active: 'var(--accents-tertiary-text-active)',
            activeAction: 'var(--accents-tertiary-text-active-action)',
        },
    },
};
const AccentIllustrations = {
    primary: {
        tint1: 'var(--accents-primary-tint-1)',
        tint2: 'var(--accents-primary-tint-2)',
        tint3: 'var(--accents-primary-tint-3)',
        tint4: 'var(--accents-primary-tint-4)',
        tint5: 'var(--accents-primary-tint-5)',
        tint6: 'var(--accents-primary-tint-6)',
    },
    secondary: {
        tint1: 'var(--accents-secondary-tint-1)',
        tint2: 'var(--accents-secondary-tint-2)',
        tint3: 'var(--accents-secondary-tint-3)',
        tint4: 'var(--accents-secondary-tint-4)',
        tint5: 'var(--accents-secondary-tint-5)',
        tint6: 'var(--accents-secondary-tint-6)',
    },
};

export { AccentIllustrations, Accents, convertAccentIllustrationsToCSS, convertAccentIllustrationsToObject, convertAccentsToCSS, convertAccentsToObject };
